module.exports = __webpack_public_path__ + "img/43aaa2f.png";